import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./LayoutComponents/Dashboard";
import VarNavigationBar from "./LayoutComponents/VarNavigationBar";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.css";
import Footer from "./LayoutComponents/Footer";
import AboutUs from "./LayoutComponents/AboutUs";
import Services from "./LayoutComponents/Services";
import ContactUs from "./LayoutComponents/ContactUs";
import NabhNahlAccr from "./LayoutComponents/NabhNahlAccr";
import DueDiligence from "./LayoutComponents/DueDiligence";

function App() {
  return (
    <Router>
      <div className={"background-container"}>
        <VarNavigationBar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route
            path="/services/nabh-nabl-accreditation"
            element={<NabhNahlAccr />}
          />
          <Route path="/services/due-diligence" element={<DueDiligence />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
